import React, { useState, useRef } from 'react'
import styled from 'styled-components'
import media from 'utils/media'
import useOnClickOutside from 'utils/hooks/useOnClickOutside'
import Button from 'components/elements/Button'
import FontAwesome from 'components/FontAwesome'
import NewsletterForm from 'components/elements/NewsletterForm'
import { DecoratedBox, StyledSpan } from './styles'

export default function Newsletter({ text }) {
   const [isOpen, setIsOpen] = useState(false)
   const mainRef = useRef(null)

   useOnClickOutside(mainRef, () => setIsOpen(false))
   return (
      <Container ref={mainRef}>
         <StyledButton variant="light" onClick={() => setIsOpen(!isOpen)}>
            <StyledSpan>Newsletter</StyledSpan>
         </StyledButton>

         {isOpen && (
            <FormContainer>
               {text && text.content && <StyledText>{text.content}</StyledText>}
               <NewsletterForm placeholder="Join our newsletter" />
            </FormContainer>
         )}
      </Container>
   )
}

const Container = styled.div`
   ${media.greaterThan('md')`
      position: relative;
   `};
`
const StyledButton = styled(Button)`
   padding-left: 8px;
   padding-right: 8px;

   @media (min-width: 360px) {
      padding-left: 14.5px;
      padding-right: 14.5px;
   }
`

const FormContainer = styled(DecoratedBox)`
   width: 100%;
   position: absolute;
   top: 108%;
   right: 0;
   ${media.greaterThan('sm')`
      width: 450px;
   `};
   ${media.greaterThan('md')`
      top: 130%;
   `};
`

const StyledText = styled.p`
   font-size: 16px;
   line-height: 29px;
   letter-spacing: 0.02em;
   margin-bottom: 12px;
`

export const StyledIcon = styled(FontAwesome).attrs(({ theme }) => ({
   icon: 'emailOutline',
}))`
   display: block;
   color: inherit;
   color: ${({ theme }) => theme.colors.accent};
   position: absolute;
   left: 12px;
   top: 50%;
   transform: translateY(-50%);
   font-size: 13px;
`
